export { default as ChatAltOutlineIcon } from './ChatAltOutlineIcon';
